import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: -35px;\n  left: 0px;\n  background-color: white;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 8px;\n  border-color: rgb(218, 220, 224);\n  box-shadow: rgba(60, 64, 67, 0.15) 0px 4px 8px 3px;\n  z-index: 10;\n'], ['\n  position: absolute;\n  bottom: -35px;\n  left: 0px;\n  background-color: white;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 8px;\n  border-color: rgb(218, 220, 224);\n  box-shadow: rgba(60, 64, 67, 0.15) 0px 4px 8px 3px;\n  z-index: 10;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-left: 5px;\n  width: 180px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n'], ['\n  margin-left: 5px;\n  width: 180px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n']);

import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Icon from '../Icon';

var Link = function (_PureComponent) {
  _inherits(Link, _PureComponent);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showLinkClicker: false
    }, _this.registerHandlers = function () {
      document.addEventListener('mousedown', _this.handleOutsideClick);
      document.addEventListener('touchstart', _this.handleOutsideClick);
    }, _this.unregisterHandlers = function () {
      document.removeEventListener('mousedown', _this.handleOutsideClick);
      document.removeEventListener('touchstart', _this.handleOutsideClick);
    }, _this.handleOutsideClick = function (e) {
      if (!_this.linkContainer.contains(e.target) && (!_this.linkClicker || !_this.linkClicker.contains(e.target))) {
        _this.setState({ showLinkClicker: false });
      }
    }, _this.setRef = function (ref) {
      _this.linkContainer = ref;
    }, _this.setLinkClickerRef = function (ref) {
      _this.linkClicker = ref;
    }, _this.onClick = function (e) {
      var _this$props = _this.props,
          href = _this$props.href,
          onLinkOpen = _this$props.onLinkOpen,
          onFocus = _this$props.onFocus,
          isMobile = _this$props.isMobile;

      if (isMobile) {
        e.preventDefault();
        e.stopPropagation();
        onLinkOpen && onLinkOpen(href);
      } else {
        _this.setState({ showLinkClicker: true });
      }
    }, _this.openLinkOnWeb = function () {
      window.open(_this.props.href, '_blank');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.registerHandlers();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unregisterHandlers();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          href = _props.href,
          rel = _props.rel,
          className = _props.className,
          children = _props.children;
      var showLinkClicker = this.state.showLinkClicker;


      return React.createElement(
        LinkContainer,
        null,
        React.createElement(
          'a',
          { className: className, ref: this.setRef, href: href, onClick: this.onClick, rel: rel, target: '_blank' },
          children
        ),
        showLinkClicker && React.createElement(
          LinkClicker,
          { ref: this.setLinkClickerRef, onClick: this.openLinkOnWeb },
          React.createElement(Icon, { size: 20, icon: 'ExternalLink' }),
          React.createElement(
            LinkHolder,
            null,
            this.props.href
          )
        )
      );
    }
  }]);

  return Link;
}(PureComponent);

Link.propTypes = {
  href: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  onLinkOpen: PropTypes.func,
  isMobile: PropTypes.bool
};


var LinkContainer = styled.span(_templateObject);

var LinkClicker = styled.a(_templateObject2);

var LinkHolder = styled.div(_templateObject3);

export default Link;
//# sourceMappingURL=Link.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/DraftEditor/Link.js
// module id = 993
// module chunks = 0